export const environment = {
  production: false,
  apiUrlIdentity: 'https://asv-identity-backend-main.k3s.flycatchtech.in',
  apiUrlJobTicket: 'https://asv-job-ticket-backend-dev.k3s.flycatchtech.in',
  pdfUrl: 'https://asv-pdf-generator-dev.k3s.flycatchtech.in/generate-pdf',
};
